/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

export type Icon12 =
  | 'AccountSummary12'
  | 'Alert12'
  | 'AllDayTrading12'
  | 'ArrowDown12'
  | 'ArrowDownFill12'
  | 'ArrowLeft12'
  | 'ArrowLeftFill12'
  | 'ArrowRight12'
  | 'ArrowRightFill12'
  | 'ArrowUp12'
  | 'ArrowUpFill12'
  | 'BubbleChecked12'
  | 'CaretDown12'
  | 'CaretLeft12'
  | 'CaretRight12'
  | 'CaretUp12'
  | 'Checkmark12'
  | 'Close12'
  | 'ConsumerGoods12'
  | 'Copy12'
  | 'Crypto12'
  | 'DollarSign12'
  | 'Dot12'
  | 'Download12'
  | 'Drag12'
  | 'Dropdown12'
  | 'Edit12'
  | 'Energy12'
  | 'Etf12'
  | 'Exclamation12'
  | 'Filter12'
  | 'Finance12'
  | 'Gift12'
  | 'Hamburger12'
  | 'Healthcare12'
  | 'Hospitality12'
  | 'Info12'
  | 'InfoFilled12'
  | 'Lightning12'
  | 'LinkOut12'
  | 'Lock12'
  | 'Manufacturing12'
  | 'Margin12'
  | 'Minus12'
  | 'Payment12'
  | 'PercentSign12'
  | 'Person12'
  | 'Plus12'
  | 'Question12'
  | 'QuestionFilled12'
  | 'Recurring12'
  | 'Retirement12'
  | 'RollingPosition12'
  | 'Settings12'
  | 'SparkleBullet12'
  | 'StarFilled12'
  | 'StockDown12'
  | 'StockUp12'
  | 'Technology12'
  | 'Trash12'
  | 'Unlock12'

export type ServerIcon12 =
  | 'account_summary_12'
  | 'alert_12'
  | 'all_day_trading_12'
  | 'arrow_down_12'
  | 'arrow_down_fill_12'
  | 'arrow_left_12'
  | 'arrow_left_fill_12'
  | 'arrow_right_12'
  | 'arrow_right_fill_12'
  | 'arrow_up_12'
  | 'arrow_up_fill_12'
  | 'bubble_checked_12'
  | 'caret_down_12'
  | 'caret_left_12'
  | 'caret_right_12'
  | 'caret_up_12'
  | 'checkmark_12'
  | 'close_12'
  | 'consumer_goods_12'
  | 'copy_12'
  | 'crypto_12'
  | 'dollar_sign_12'
  | 'dot_12'
  | 'download_12'
  | 'drag_12'
  | 'dropdown_12'
  | 'edit_12'
  | 'energy_12'
  | 'etf_12'
  | 'exclamation_12'
  | 'filter_12'
  | 'finance_12'
  | 'gift_12'
  | 'hamburger_12'
  | 'healthcare_12'
  | 'hospitality_12'
  | 'info_12'
  | 'info_filled_12'
  | 'lightning_12'
  | 'link_out_12'
  | 'lock_12'
  | 'manufacturing_12'
  | 'margin_12'
  | 'minus_12'
  | 'payment_12'
  | 'percent_sign_12'
  | 'person_12'
  | 'plus_12'
  | 'question_12'
  | 'question_filled_12'
  | 'recurring_12'
  | 'retirement_12'
  | 'rolling_position_12'
  | 'settings_12'
  | 'sparkle_bullet_12'
  | 'star_filled_12'
  | 'stock_down_12'
  | 'stock_up_12'
  | 'technology_12'
  | 'trash_12'
  | 'unlock_12'

export const ICONS_12_LIST: Array<Icon12> = [
  'AccountSummary12',
  'Alert12',
  'AllDayTrading12',
  'ArrowDown12',
  'ArrowDownFill12',
  'ArrowLeft12',
  'ArrowLeftFill12',
  'ArrowRight12',
  'ArrowRightFill12',
  'ArrowUp12',
  'ArrowUpFill12',
  'BubbleChecked12',
  'CaretDown12',
  'CaretLeft12',
  'CaretRight12',
  'CaretUp12',
  'Checkmark12',
  'Close12',
  'ConsumerGoods12',
  'Copy12',
  'Crypto12',
  'DollarSign12',
  'Dot12',
  'Download12',
  'Drag12',
  'Dropdown12',
  'Edit12',
  'Energy12',
  'Etf12',
  'Exclamation12',
  'Filter12',
  'Finance12',
  'Gift12',
  'Hamburger12',
  'Healthcare12',
  'Hospitality12',
  'Info12',
  'InfoFilled12',
  'Lightning12',
  'LinkOut12',
  'Lock12',
  'Manufacturing12',
  'Margin12',
  'Minus12',
  'Payment12',
  'PercentSign12',
  'Person12',
  'Plus12',
  'Question12',
  'QuestionFilled12',
  'Recurring12',
  'Retirement12',
  'RollingPosition12',
  'Settings12',
  'SparkleBullet12',
  'StarFilled12',
  'StockDown12',
  'StockUp12',
  'Technology12',
  'Trash12',
  'Unlock12',
]

const ICONS_12_SERVER_NAME_MAPPING: { [k in ServerIcon12]: Icon12 } = {
  account_summary_12: 'AccountSummary12',
  alert_12: 'Alert12',
  all_day_trading_12: 'AllDayTrading12',
  arrow_down_12: 'ArrowDown12',
  arrow_down_fill_12: 'ArrowDownFill12',
  arrow_left_12: 'ArrowLeft12',
  arrow_left_fill_12: 'ArrowLeftFill12',
  arrow_right_12: 'ArrowRight12',
  arrow_right_fill_12: 'ArrowRightFill12',
  arrow_up_12: 'ArrowUp12',
  arrow_up_fill_12: 'ArrowUpFill12',
  bubble_checked_12: 'BubbleChecked12',
  caret_down_12: 'CaretDown12',
  caret_left_12: 'CaretLeft12',
  caret_right_12: 'CaretRight12',
  caret_up_12: 'CaretUp12',
  checkmark_12: 'Checkmark12',
  close_12: 'Close12',
  consumer_goods_12: 'ConsumerGoods12',
  copy_12: 'Copy12',
  crypto_12: 'Crypto12',
  dollar_sign_12: 'DollarSign12',
  dot_12: 'Dot12',
  download_12: 'Download12',
  drag_12: 'Drag12',
  dropdown_12: 'Dropdown12',
  edit_12: 'Edit12',
  energy_12: 'Energy12',
  etf_12: 'Etf12',
  exclamation_12: 'Exclamation12',
  filter_12: 'Filter12',
  finance_12: 'Finance12',
  gift_12: 'Gift12',
  hamburger_12: 'Hamburger12',
  healthcare_12: 'Healthcare12',
  hospitality_12: 'Hospitality12',
  info_12: 'Info12',
  info_filled_12: 'InfoFilled12',
  lightning_12: 'Lightning12',
  link_out_12: 'LinkOut12',
  lock_12: 'Lock12',
  manufacturing_12: 'Manufacturing12',
  margin_12: 'Margin12',
  minus_12: 'Minus12',
  payment_12: 'Payment12',
  percent_sign_12: 'PercentSign12',
  person_12: 'Person12',
  plus_12: 'Plus12',
  question_12: 'Question12',
  question_filled_12: 'QuestionFilled12',
  recurring_12: 'Recurring12',
  retirement_12: 'Retirement12',
  rolling_position_12: 'RollingPosition12',
  settings_12: 'Settings12',
  sparkle_bullet_12: 'SparkleBullet12',
  star_filled_12: 'StarFilled12',
  stock_down_12: 'StockDown12',
  stock_up_12: 'StockUp12',
  technology_12: 'Technology12',
  trash_12: 'Trash12',
  unlock_12: 'Unlock12',
}

export type Icon16 =
  | 'Agent16'
  | 'Alert16'
  | 'AlertFilled16'
  | 'AllDayTrading16'
  | 'Announcement16'
  | 'ArrowDown16'
  | 'ArrowDownFill16'
  | 'ArrowLeft16'
  | 'ArrowLeftFill16'
  | 'ArrowRight16'
  | 'ArrowRightFill16'
  | 'ArrowUp16'
  | 'ArrowUpFill16'
  | 'Banking16'
  | 'BubbleChecked16'
  | 'BubblePlus16'
  | 'BubbleRemove16'
  | 'BubbleRemoveFilled16'
  | 'BubbleUkPounds16'
  | 'BubbleUkPoundsFilled16'
  | 'Builder16'
  | 'Calendar16'
  | 'Camera16'
  | 'CaretDown16'
  | 'CaretLeft16'
  | 'CaretRight16'
  | 'CaretUp16'
  | 'ChartCandlesticks16'
  | 'ChartLine16'
  | 'Chat16'
  | 'Chatbot16'
  | 'CheckboxEmpty16'
  | 'CheckboxFilled16'
  | 'Checkmark16'
  | 'Clipboard16'
  | 'Clock16'
  | 'Close16'
  | 'Cloud16'
  | 'Collapse16'
  | 'ConsumerGoods16'
  | 'Controls16'
  | 'Conversation16'
  | 'Copy16'
  | 'Corporate16'
  | 'Dividend16'
  | 'DollarSign16'
  | 'Dot16'
  | 'Dots16'
  | 'DotsAndroid16'
  | 'Download16'
  | 'Drag16'
  | 'Dropdown16'
  | 'Edit16'
  | 'EmailFilled16'
  | 'Exclamation16'
  | 'Expand16'
  | 'Eye16'
  | 'EyeClosed16'
  | 'FaceIdAndroid16'
  | 'FaceIdIos16'
  | 'Filter16'
  | 'Folder16'
  | 'Gift16'
  | 'Hamburger16'
  | 'History16'
  | 'Hourglass16'
  | 'Image16'
  | 'ImageFail16'
  | 'Info16'
  | 'InfoFilled16'
  | 'Lightbulb16'
  | 'Lightning16'
  | 'LightningOff16'
  | 'Link16'
  | 'LinkOut16'
  | 'LocationFill16'
  | 'Lock16'
  | 'Margin16'
  | 'Maximum16'
  | 'MessageSend16'
  | 'Minimum16'
  | 'Minus16'
  | 'News16'
  | 'Notification16'
  | 'NotificationAdd16'
  | 'Online16'
  | 'Order16'
  | 'Payment16'
  | 'PercentSign16'
  | 'Person16'
  | 'Phone16'
  | 'PhoneConnected16'
  | 'PhoneMissedCall16'
  | 'PhoneWaiting16'
  | 'Pin16'
  | 'PlayInline16'
  | 'Plus16'
  | 'PopOut16'
  | 'Qr16'
  | 'Quantity16'
  | 'Question16'
  | 'QuestionFilled16'
  | 'Recurring16'
  | 'Repeat16'
  | 'Resend16'
  | 'Retirement16'
  | 'Robinhood16'
  | 'RollingPosition16'
  | 'Scan16'
  | 'Search16'
  | 'Settings16'
  | 'ShareAndroid16'
  | 'ShareIos16'
  | 'SparkleBullet16'
  | 'StarFilled16'
  | 'StarOutline16'
  | 'StockDown16'
  | 'StockUp16'
  | 'Stopwatch16'
  | 'SwipeDown16'
  | 'SwipeUp16'
  | 'Switch16'
  | 'Tag16'
  | 'Thumbprint16'
  | 'ThumbsDown16'
  | 'ThumbsUp16'
  | 'Ticket16'
  | 'TouchIdAndroid16'
  | 'Transfers16'
  | 'Trash16'
  | 'TriangleAlert16'
  | 'Tuner16'
  | 'Unlock16'
  | 'Walletconnect16'

export type ServerIcon16 =
  | 'agent_16'
  | 'alert_16'
  | 'alert_filled_16'
  | 'all_day_trading_16'
  | 'announcement_16'
  | 'arrow_down_16'
  | 'arrow_down_fill_16'
  | 'arrow_left_16'
  | 'arrow_left_fill_16'
  | 'arrow_right_16'
  | 'arrow_right_fill_16'
  | 'arrow_up_16'
  | 'arrow_up_fill_16'
  | 'banking_16'
  | 'bubble_checked_16'
  | 'bubble_plus_16'
  | 'bubble_remove_16'
  | 'bubble_remove_filled_16'
  | 'bubble_uk_pounds_16'
  | 'bubble_uk_pounds_filled_16'
  | 'builder_16'
  | 'calendar_16'
  | 'camera_16'
  | 'caret_down_16'
  | 'caret_left_16'
  | 'caret_right_16'
  | 'caret_up_16'
  | 'chart_candlesticks_16'
  | 'chart_line_16'
  | 'chat_16'
  | 'chatbot_16'
  | 'checkbox_empty_16'
  | 'checkbox_filled_16'
  | 'checkmark_16'
  | 'clipboard_16'
  | 'clock_16'
  | 'close_16'
  | 'cloud_16'
  | 'collapse_16'
  | 'consumer_goods_16'
  | 'controls_16'
  | 'conversation_16'
  | 'copy_16'
  | 'corporate_16'
  | 'dividend_16'
  | 'dollar_sign_16'
  | 'dot_16'
  | 'dots_16'
  | 'dots_android_16'
  | 'download_16'
  | 'drag_16'
  | 'dropdown_16'
  | 'edit_16'
  | 'email_filled_16'
  | 'exclamation_16'
  | 'expand_16'
  | 'eye_16'
  | 'eye_closed_16'
  | 'face_id_android_16'
  | 'face_id_ios_16'
  | 'filter_16'
  | 'folder_16'
  | 'gift_16'
  | 'hamburger_16'
  | 'history_16'
  | 'hourglass_16'
  | 'image_16'
  | 'image_fail_16'
  | 'info_16'
  | 'info_filled_16'
  | 'lightbulb_16'
  | 'lightning_16'
  | 'lightning_off_16'
  | 'link_16'
  | 'link_out_16'
  | 'location_fill_16'
  | 'lock_16'
  | 'margin_16'
  | 'maximum_16'
  | 'message_send_16'
  | 'minimum_16'
  | 'minus_16'
  | 'news_16'
  | 'notification_16'
  | 'notification_add_16'
  | 'online_16'
  | 'order_16'
  | 'payment_16'
  | 'percent_sign_16'
  | 'person_16'
  | 'phone_16'
  | 'phone_connected_16'
  | 'phone_missed_call_16'
  | 'phone_waiting_16'
  | 'pin_16'
  | 'play_inline_16'
  | 'plus_16'
  | 'pop_out_16'
  | 'qr_16'
  | 'quantity_16'
  | 'question_16'
  | 'question_filled_16'
  | 'recurring_16'
  | 'repeat_16'
  | 'resend_16'
  | 'retirement_16'
  | 'robinhood_16'
  | 'rolling_position_16'
  | 'scan_16'
  | 'search_16'
  | 'settings_16'
  | 'share_android_16'
  | 'share_ios_16'
  | 'sparkle_bullet_16'
  | 'star_filled_16'
  | 'star_outline_16'
  | 'stock_down_16'
  | 'stock_up_16'
  | 'stopwatch_16'
  | 'swipe_down_16'
  | 'swipe_up_16'
  | 'switch_16'
  | 'tag_16'
  | 'thumbprint_16'
  | 'thumbs_down_16'
  | 'thumbs_up_16'
  | 'ticket_16'
  | 'touch_id_android_16'
  | 'transfers_16'
  | 'trash_16'
  | 'triangle_alert_16'
  | 'tuner_16'
  | 'unlock_16'
  | 'walletconnect_16'

export const ICONS_16_LIST: Array<Icon16> = [
  'Agent16',
  'Alert16',
  'AlertFilled16',
  'AllDayTrading16',
  'Announcement16',
  'ArrowDown16',
  'ArrowDownFill16',
  'ArrowLeft16',
  'ArrowLeftFill16',
  'ArrowRight16',
  'ArrowRightFill16',
  'ArrowUp16',
  'ArrowUpFill16',
  'Banking16',
  'BubbleChecked16',
  'BubblePlus16',
  'BubbleRemove16',
  'BubbleRemoveFilled16',
  'BubbleUkPounds16',
  'BubbleUkPoundsFilled16',
  'Builder16',
  'Calendar16',
  'Camera16',
  'CaretDown16',
  'CaretLeft16',
  'CaretRight16',
  'CaretUp16',
  'ChartCandlesticks16',
  'ChartLine16',
  'Chat16',
  'Chatbot16',
  'CheckboxEmpty16',
  'CheckboxFilled16',
  'Checkmark16',
  'Clipboard16',
  'Clock16',
  'Close16',
  'Cloud16',
  'Collapse16',
  'ConsumerGoods16',
  'Controls16',
  'Conversation16',
  'Copy16',
  'Corporate16',
  'Dividend16',
  'DollarSign16',
  'Dot16',
  'Dots16',
  'DotsAndroid16',
  'Download16',
  'Drag16',
  'Dropdown16',
  'Edit16',
  'EmailFilled16',
  'Exclamation16',
  'Expand16',
  'Eye16',
  'EyeClosed16',
  'FaceIdAndroid16',
  'FaceIdIos16',
  'Filter16',
  'Folder16',
  'Gift16',
  'Hamburger16',
  'History16',
  'Hourglass16',
  'Image16',
  'ImageFail16',
  'Info16',
  'InfoFilled16',
  'Lightbulb16',
  'Lightning16',
  'LightningOff16',
  'Link16',
  'LinkOut16',
  'LocationFill16',
  'Lock16',
  'Margin16',
  'Maximum16',
  'MessageSend16',
  'Minimum16',
  'Minus16',
  'News16',
  'Notification16',
  'NotificationAdd16',
  'Online16',
  'Order16',
  'Payment16',
  'PercentSign16',
  'Person16',
  'Phone16',
  'PhoneConnected16',
  'PhoneMissedCall16',
  'PhoneWaiting16',
  'Pin16',
  'PlayInline16',
  'Plus16',
  'PopOut16',
  'Qr16',
  'Quantity16',
  'Question16',
  'QuestionFilled16',
  'Recurring16',
  'Repeat16',
  'Resend16',
  'Retirement16',
  'Robinhood16',
  'RollingPosition16',
  'Scan16',
  'Search16',
  'Settings16',
  'ShareAndroid16',
  'ShareIos16',
  'SparkleBullet16',
  'StarFilled16',
  'StarOutline16',
  'StockDown16',
  'StockUp16',
  'Stopwatch16',
  'SwipeDown16',
  'SwipeUp16',
  'Switch16',
  'Tag16',
  'Thumbprint16',
  'ThumbsDown16',
  'ThumbsUp16',
  'Ticket16',
  'TouchIdAndroid16',
  'Transfers16',
  'Trash16',
  'TriangleAlert16',
  'Tuner16',
  'Unlock16',
  'Walletconnect16',
]

const ICONS_16_SERVER_NAME_MAPPING: { [k in ServerIcon16]: Icon16 } = {
  agent_16: 'Agent16',
  alert_16: 'Alert16',
  alert_filled_16: 'AlertFilled16',
  all_day_trading_16: 'AllDayTrading16',
  announcement_16: 'Announcement16',
  arrow_down_16: 'ArrowDown16',
  arrow_down_fill_16: 'ArrowDownFill16',
  arrow_left_16: 'ArrowLeft16',
  arrow_left_fill_16: 'ArrowLeftFill16',
  arrow_right_16: 'ArrowRight16',
  arrow_right_fill_16: 'ArrowRightFill16',
  arrow_up_16: 'ArrowUp16',
  arrow_up_fill_16: 'ArrowUpFill16',
  banking_16: 'Banking16',
  bubble_checked_16: 'BubbleChecked16',
  bubble_plus_16: 'BubblePlus16',
  bubble_remove_16: 'BubbleRemove16',
  bubble_remove_filled_16: 'BubbleRemoveFilled16',
  bubble_uk_pounds_16: 'BubbleUkPounds16',
  bubble_uk_pounds_filled_16: 'BubbleUkPoundsFilled16',
  builder_16: 'Builder16',
  calendar_16: 'Calendar16',
  camera_16: 'Camera16',
  caret_down_16: 'CaretDown16',
  caret_left_16: 'CaretLeft16',
  caret_right_16: 'CaretRight16',
  caret_up_16: 'CaretUp16',
  chart_candlesticks_16: 'ChartCandlesticks16',
  chart_line_16: 'ChartLine16',
  chat_16: 'Chat16',
  chatbot_16: 'Chatbot16',
  checkbox_empty_16: 'CheckboxEmpty16',
  checkbox_filled_16: 'CheckboxFilled16',
  checkmark_16: 'Checkmark16',
  clipboard_16: 'Clipboard16',
  clock_16: 'Clock16',
  close_16: 'Close16',
  cloud_16: 'Cloud16',
  collapse_16: 'Collapse16',
  consumer_goods_16: 'ConsumerGoods16',
  controls_16: 'Controls16',
  conversation_16: 'Conversation16',
  copy_16: 'Copy16',
  corporate_16: 'Corporate16',
  dividend_16: 'Dividend16',
  dollar_sign_16: 'DollarSign16',
  dot_16: 'Dot16',
  dots_16: 'Dots16',
  dots_android_16: 'DotsAndroid16',
  download_16: 'Download16',
  drag_16: 'Drag16',
  dropdown_16: 'Dropdown16',
  edit_16: 'Edit16',
  email_filled_16: 'EmailFilled16',
  exclamation_16: 'Exclamation16',
  expand_16: 'Expand16',
  eye_16: 'Eye16',
  eye_closed_16: 'EyeClosed16',
  face_id_android_16: 'FaceIdAndroid16',
  face_id_ios_16: 'FaceIdIos16',
  filter_16: 'Filter16',
  folder_16: 'Folder16',
  gift_16: 'Gift16',
  hamburger_16: 'Hamburger16',
  history_16: 'History16',
  hourglass_16: 'Hourglass16',
  image_16: 'Image16',
  image_fail_16: 'ImageFail16',
  info_16: 'Info16',
  info_filled_16: 'InfoFilled16',
  lightbulb_16: 'Lightbulb16',
  lightning_16: 'Lightning16',
  lightning_off_16: 'LightningOff16',
  link_16: 'Link16',
  link_out_16: 'LinkOut16',
  location_fill_16: 'LocationFill16',
  lock_16: 'Lock16',
  margin_16: 'Margin16',
  maximum_16: 'Maximum16',
  message_send_16: 'MessageSend16',
  minimum_16: 'Minimum16',
  minus_16: 'Minus16',
  news_16: 'News16',
  notification_16: 'Notification16',
  notification_add_16: 'NotificationAdd16',
  online_16: 'Online16',
  order_16: 'Order16',
  payment_16: 'Payment16',
  percent_sign_16: 'PercentSign16',
  person_16: 'Person16',
  phone_16: 'Phone16',
  phone_connected_16: 'PhoneConnected16',
  phone_missed_call_16: 'PhoneMissedCall16',
  phone_waiting_16: 'PhoneWaiting16',
  pin_16: 'Pin16',
  play_inline_16: 'PlayInline16',
  plus_16: 'Plus16',
  pop_out_16: 'PopOut16',
  qr_16: 'Qr16',
  quantity_16: 'Quantity16',
  question_16: 'Question16',
  question_filled_16: 'QuestionFilled16',
  recurring_16: 'Recurring16',
  repeat_16: 'Repeat16',
  resend_16: 'Resend16',
  retirement_16: 'Retirement16',
  robinhood_16: 'Robinhood16',
  rolling_position_16: 'RollingPosition16',
  scan_16: 'Scan16',
  search_16: 'Search16',
  settings_16: 'Settings16',
  share_android_16: 'ShareAndroid16',
  share_ios_16: 'ShareIos16',
  sparkle_bullet_16: 'SparkleBullet16',
  star_filled_16: 'StarFilled16',
  star_outline_16: 'StarOutline16',
  stock_down_16: 'StockDown16',
  stock_up_16: 'StockUp16',
  stopwatch_16: 'Stopwatch16',
  swipe_down_16: 'SwipeDown16',
  swipe_up_16: 'SwipeUp16',
  switch_16: 'Switch16',
  tag_16: 'Tag16',
  thumbprint_16: 'Thumbprint16',
  thumbs_down_16: 'ThumbsDown16',
  thumbs_up_16: 'ThumbsUp16',
  ticket_16: 'Ticket16',
  touch_id_android_16: 'TouchIdAndroid16',
  transfers_16: 'Transfers16',
  trash_16: 'Trash16',
  triangle_alert_16: 'TriangleAlert16',
  tuner_16: 'Tuner16',
  unlock_16: 'Unlock16',
  walletconnect_16: 'Walletconnect16',
}

export type Icon24 =
  | 'AccountSummary24'
  | 'ActionRemove24'
  | 'Agent24'
  | 'Alert24'
  | 'AlertFilled24'
  | 'AllDayTrading24'
  | 'Announcement24'
  | 'Archive24'
  | 'ArrowDown24'
  | 'ArrowDownFill24'
  | 'ArrowLeft24'
  | 'ArrowLeftFill24'
  | 'ArrowRight24'
  | 'ArrowRightFill24'
  | 'ArrowUp24'
  | 'ArrowUpFill24'
  | 'Attach24'
  | 'Backspace24'
  | 'Banking24'
  | 'BubbleChecked24'
  | 'BubbleDot24'
  | 'BubbleEmpty24'
  | 'BubblePause24'
  | 'BubblePlus24'
  | 'BubblePlusFilled24'
  | 'BubbleRadioButton24'
  | 'BubbleRemove24'
  | 'BubbleRemoveFilled24'
  | 'BubbleReverse24'
  | 'BubbleUkPounds24'
  | 'BubbleUkPoundsFilled24'
  | 'Builder24'
  | 'Calendar24'
  | 'Camera24'
  | 'CaretDown24'
  | 'CaretLeft24'
  | 'CaretRight24'
  | 'CaretUp24'
  | 'Cash24'
  | 'Chart24'
  | 'ChartCandlesticks24'
  | 'ChartLine24'
  | 'Chat24'
  | 'Chatbot24'
  | 'CheckboxEmpty24'
  | 'CheckboxFilled24'
  | 'Checkmark24'
  | 'Clipboard24'
  | 'Clock24'
  | 'Close24'
  | 'Cloud24'
  | 'Collapse24'
  | 'ConsumerGoods24'
  | 'Controls24'
  | 'Conversation24'
  | 'Copy24'
  | 'Corporate24'
  | 'Crypto24'
  | 'CryptoC24'
  | 'Deposit24'
  | 'Dining24'
  | 'Disclosures24'
  | 'Dividend24'
  | 'Documents24'
  | 'DollarSign24'
  | 'Dot24'
  | 'Dots24'
  | 'DotsAndroid24'
  | 'Download24'
  | 'Drag24'
  | 'Dropdown24'
  | 'EconomicMoat24'
  | 'Edit24'
  | 'EditSurface24'
  | 'EmailFilled24'
  | 'EmailOutline24'
  | 'Energy24'
  | 'Entertainment24'
  | 'Etf24'
  | 'Exclamation24'
  | 'Expand24'
  | 'Eye24'
  | 'EyeClosed24'
  | 'FaceIdAndroid24'
  | 'FaceIdIos24'
  | 'FairValue24'
  | 'Filter24'
  | 'Finance24'
  | 'FlashOff24'
  | 'FlashOn24'
  | 'FlashlightOff24'
  | 'FlashlightOn24'
  | 'Folder24'
  | 'FullscreenEnter24'
  | 'FullscreenExit24'
  | 'Gift24'
  | 'Groceries24'
  | 'Hamburger24'
  | 'Healthcare24'
  | 'Help24'
  | 'History24'
  | 'Home24'
  | 'Hospitality24'
  | 'Hourglass24'
  | 'IcloudRestore24'
  | 'Image24'
  | 'ImageFail24'
  | 'Info24'
  | 'InfoFilled24'
  | 'L2HeaderArrow24'
  | 'Lightbulb24'
  | 'Lightning24'
  | 'Link24'
  | 'LinkOut24'
  | 'LocationFill24'
  | 'LocationOutline24'
  | 'Lock24'
  | 'LogOut24'
  | 'Manufacturing24'
  | 'Maps24'
  | 'Margin24'
  | 'MessageSend24'
  | 'Minus24'
  | 'News24'
  | 'NoValue24'
  | 'Notification24'
  | 'NotificationAdd24'
  | 'Online24'
  | 'OptionsDown24'
  | 'OptionsFlat24'
  | 'OptionsUp24'
  | 'OptionsVolatile24'
  | 'Order24'
  | 'PauseInline24'
  | 'Paycheck24'
  | 'Payment24'
  | 'PercentSign24'
  | 'Person24'
  | 'Phone24'
  | 'Pin24'
  | 'PlayInline24'
  | 'Plus24'
  | 'PopOut24'
  | 'Print24'
  | 'Qr24'
  | 'QrScan24'
  | 'Quantity24'
  | 'Question24'
  | 'QuestionFilled24'
  | 'Recurring24'
  | 'RecurringHub24'
  | 'Resend24'
  | 'Retirement24'
  | 'RhwBrowserTab24'
  | 'RhwChartTab24'
  | 'RhwSearchTab24'
  | 'RiskAndUncertainty24'
  | 'Robinhood24'
  | 'RollingPosition24'
  | 'Scan24'
  | 'Search24'
  | 'Settings24'
  | 'ShareAndroid24'
  | 'ShareIos24'
  | 'Smiley24'
  | 'SoundOff24'
  | 'SoundOn24'
  | 'SparkleBullet24'
  | 'StarFilled24'
  | 'StarOutline24'
  | 'Stewardship24'
  | 'StockDown24'
  | 'StockUp24'
  | 'Stopwatch24'
  | 'StrategyOutlook24'
  | 'SwipeDown24'
  | 'SwipeUp24'
  | 'Switch24'
  | 'Tag24'
  | 'Technology24'
  | 'Thumbprint24'
  | 'ThumbsDown24'
  | 'ThumbsUp24'
  | 'Ticket24'
  | 'TouchIdAndroid24'
  | 'Transfers24'
  | 'Transport24'
  | 'Trash24'
  | 'TriangleAlert24'
  | 'Tuner24'
  | 'Unlock24'
  | 'Upload24'
  | 'VideoFastForward24'
  | 'VideoReplay24'
  | 'VideoRewind24'
  | 'Wallet24'
  | 'Walletconnect24'
  | 'WcScan24'
  | 'Withdraw24'
  | 'ZoomIn24'
  | 'ZoomOut24'

export type ServerIcon24 =
  | 'account_summary_24'
  | 'action_remove_24'
  | 'agent_24'
  | 'alert_24'
  | 'alert_filled_24'
  | 'all_day_trading_24'
  | 'announcement_24'
  | 'archive_24'
  | 'arrow_down_24'
  | 'arrow_down_fill_24'
  | 'arrow_left_24'
  | 'arrow_left_fill_24'
  | 'arrow_right_24'
  | 'arrow_right_fill_24'
  | 'arrow_up_24'
  | 'arrow_up_fill_24'
  | 'attach_24'
  | 'backspace_24'
  | 'banking_24'
  | 'bubble_checked_24'
  | 'bubble_dot_24'
  | 'bubble_empty_24'
  | 'bubble_pause_24'
  | 'bubble_plus_24'
  | 'bubble_plus_filled_24'
  | 'bubble_radio_button_24'
  | 'bubble_remove_24'
  | 'bubble_remove_filled_24'
  | 'bubble_reverse_24'
  | 'bubble_uk_pounds_24'
  | 'bubble_uk_pounds_filled_24'
  | 'builder_24'
  | 'calendar_24'
  | 'camera_24'
  | 'caret_down_24'
  | 'caret_left_24'
  | 'caret_right_24'
  | 'caret_up_24'
  | 'cash_24'
  | 'chart_24'
  | 'chart_candlesticks_24'
  | 'chart_line_24'
  | 'chat_24'
  | 'chatbot_24'
  | 'checkbox_empty_24'
  | 'checkbox_filled_24'
  | 'checkmark_24'
  | 'clipboard_24'
  | 'clock_24'
  | 'close_24'
  | 'cloud_24'
  | 'collapse_24'
  | 'consumer_goods_24'
  | 'controls_24'
  | 'conversation_24'
  | 'copy_24'
  | 'corporate_24'
  | 'crypto_24'
  | 'crypto_c_24'
  | 'deposit_24'
  | 'dining_24'
  | 'disclosures_24'
  | 'dividend_24'
  | 'documents_24'
  | 'dollar_sign_24'
  | 'dot_24'
  | 'dots_24'
  | 'dots_android_24'
  | 'download_24'
  | 'drag_24'
  | 'dropdown_24'
  | 'economic_moat_24'
  | 'edit_24'
  | 'edit_surface_24'
  | 'email_filled_24'
  | 'email_outline_24'
  | 'energy_24'
  | 'entertainment_24'
  | 'etf_24'
  | 'exclamation_24'
  | 'expand_24'
  | 'eye_24'
  | 'eye_closed_24'
  | 'face_id_android_24'
  | 'face_id_ios_24'
  | 'fair_value_24'
  | 'filter_24'
  | 'finance_24'
  | 'flash_off_24'
  | 'flash_on_24'
  | 'flashlight_off_24'
  | 'flashlight_on_24'
  | 'folder_24'
  | 'fullscreen_enter_24'
  | 'fullscreen_exit_24'
  | 'gift_24'
  | 'groceries_24'
  | 'hamburger_24'
  | 'healthcare_24'
  | 'help_24'
  | 'history_24'
  | 'home_24'
  | 'hospitality_24'
  | 'hourglass_24'
  | 'icloud_restore_24'
  | 'image_24'
  | 'image_fail_24'
  | 'info_24'
  | 'info_filled_24'
  | 'l2_header_arrow_24'
  | 'lightbulb_24'
  | 'lightning_24'
  | 'link_24'
  | 'link_out_24'
  | 'location_fill_24'
  | 'location_outline_24'
  | 'lock_24'
  | 'log_out_24'
  | 'manufacturing_24'
  | 'maps_24'
  | 'margin_24'
  | 'message_send_24'
  | 'minus_24'
  | 'news_24'
  | 'no_value_24'
  | 'notification_24'
  | 'notification_add_24'
  | 'online_24'
  | 'options_down_24'
  | 'options_flat_24'
  | 'options_up_24'
  | 'options_volatile_24'
  | 'order_24'
  | 'pause_inline_24'
  | 'paycheck_24'
  | 'payment_24'
  | 'percent_sign_24'
  | 'person_24'
  | 'phone_24'
  | 'pin_24'
  | 'play_inline_24'
  | 'plus_24'
  | 'pop_out_24'
  | 'print_24'
  | 'qr_24'
  | 'qr_scan_24'
  | 'quantity_24'
  | 'question_24'
  | 'question_filled_24'
  | 'recurring_24'
  | 'recurring_hub_24'
  | 'resend_24'
  | 'retirement_24'
  | 'rhw_browser_tab_24'
  | 'rhw_chart_tab_24'
  | 'rhw_search_tab_24'
  | 'risk_and_uncertainty_24'
  | 'robinhood_24'
  | 'rolling_position_24'
  | 'scan_24'
  | 'search_24'
  | 'settings_24'
  | 'share_android_24'
  | 'share_ios_24'
  | 'smiley_24'
  | 'sound_off_24'
  | 'sound_on_24'
  | 'sparkle_bullet_24'
  | 'star_filled_24'
  | 'star_outline_24'
  | 'stewardship_24'
  | 'stock_down_24'
  | 'stock_up_24'
  | 'stopwatch_24'
  | 'strategy_outlook_24'
  | 'swipe_down_24'
  | 'swipe_up_24'
  | 'switch_24'
  | 'tag_24'
  | 'technology_24'
  | 'thumbprint_24'
  | 'thumbs_down_24'
  | 'thumbs_up_24'
  | 'ticket_24'
  | 'touch_id_android_24'
  | 'transfers_24'
  | 'transport_24'
  | 'trash_24'
  | 'triangle_alert_24'
  | 'tuner_24'
  | 'unlock_24'
  | 'upload_24'
  | 'video_fast_forward_24'
  | 'video_replay_24'
  | 'video_rewind_24'
  | 'wallet_24'
  | 'walletconnect_24'
  | 'wc_scan_24'
  | 'withdraw_24'
  | 'zoom_in_24'
  | 'zoom_out_24'

export const ICONS_24_LIST: Array<Icon24> = [
  'AccountSummary24',
  'ActionRemove24',
  'Agent24',
  'Alert24',
  'AlertFilled24',
  'AllDayTrading24',
  'Announcement24',
  'Archive24',
  'ArrowDown24',
  'ArrowDownFill24',
  'ArrowLeft24',
  'ArrowLeftFill24',
  'ArrowRight24',
  'ArrowRightFill24',
  'ArrowUp24',
  'ArrowUpFill24',
  'Attach24',
  'Backspace24',
  'Banking24',
  'BubbleChecked24',
  'BubbleDot24',
  'BubbleEmpty24',
  'BubblePause24',
  'BubblePlus24',
  'BubblePlusFilled24',
  'BubbleRadioButton24',
  'BubbleRemove24',
  'BubbleRemoveFilled24',
  'BubbleReverse24',
  'BubbleUkPounds24',
  'BubbleUkPoundsFilled24',
  'Builder24',
  'Calendar24',
  'Camera24',
  'CaretDown24',
  'CaretLeft24',
  'CaretRight24',
  'CaretUp24',
  'Cash24',
  'Chart24',
  'ChartCandlesticks24',
  'ChartLine24',
  'Chat24',
  'Chatbot24',
  'CheckboxEmpty24',
  'CheckboxFilled24',
  'Checkmark24',
  'Clipboard24',
  'Clock24',
  'Close24',
  'Cloud24',
  'Collapse24',
  'ConsumerGoods24',
  'Controls24',
  'Conversation24',
  'Copy24',
  'Corporate24',
  'Crypto24',
  'CryptoC24',
  'Deposit24',
  'Dining24',
  'Disclosures24',
  'Dividend24',
  'Documents24',
  'DollarSign24',
  'Dot24',
  'Dots24',
  'DotsAndroid24',
  'Download24',
  'Drag24',
  'Dropdown24',
  'EconomicMoat24',
  'Edit24',
  'EditSurface24',
  'EmailFilled24',
  'EmailOutline24',
  'Energy24',
  'Entertainment24',
  'Etf24',
  'Exclamation24',
  'Expand24',
  'Eye24',
  'EyeClosed24',
  'FaceIdAndroid24',
  'FaceIdIos24',
  'FairValue24',
  'Filter24',
  'Finance24',
  'FlashOff24',
  'FlashOn24',
  'FlashlightOff24',
  'FlashlightOn24',
  'Folder24',
  'FullscreenEnter24',
  'FullscreenExit24',
  'Gift24',
  'Groceries24',
  'Hamburger24',
  'Healthcare24',
  'Help24',
  'History24',
  'Home24',
  'Hospitality24',
  'Hourglass24',
  'IcloudRestore24',
  'Image24',
  'ImageFail24',
  'Info24',
  'InfoFilled24',
  'L2HeaderArrow24',
  'Lightbulb24',
  'Lightning24',
  'Link24',
  'LinkOut24',
  'LocationFill24',
  'LocationOutline24',
  'Lock24',
  'LogOut24',
  'Manufacturing24',
  'Maps24',
  'Margin24',
  'MessageSend24',
  'Minus24',
  'News24',
  'NoValue24',
  'Notification24',
  'NotificationAdd24',
  'Online24',
  'OptionsDown24',
  'OptionsFlat24',
  'OptionsUp24',
  'OptionsVolatile24',
  'Order24',
  'PauseInline24',
  'Paycheck24',
  'Payment24',
  'PercentSign24',
  'Person24',
  'Phone24',
  'Pin24',
  'PlayInline24',
  'Plus24',
  'PopOut24',
  'Print24',
  'Qr24',
  'QrScan24',
  'Quantity24',
  'Question24',
  'QuestionFilled24',
  'Recurring24',
  'RecurringHub24',
  'Resend24',
  'Retirement24',
  'RhwBrowserTab24',
  'RhwChartTab24',
  'RhwSearchTab24',
  'RiskAndUncertainty24',
  'Robinhood24',
  'RollingPosition24',
  'Scan24',
  'Search24',
  'Settings24',
  'ShareAndroid24',
  'ShareIos24',
  'Smiley24',
  'SoundOff24',
  'SoundOn24',
  'SparkleBullet24',
  'StarFilled24',
  'StarOutline24',
  'Stewardship24',
  'StockDown24',
  'StockUp24',
  'Stopwatch24',
  'StrategyOutlook24',
  'SwipeDown24',
  'SwipeUp24',
  'Switch24',
  'Tag24',
  'Technology24',
  'Thumbprint24',
  'ThumbsDown24',
  'ThumbsUp24',
  'Ticket24',
  'TouchIdAndroid24',
  'Transfers24',
  'Transport24',
  'Trash24',
  'TriangleAlert24',
  'Tuner24',
  'Unlock24',
  'Upload24',
  'VideoFastForward24',
  'VideoReplay24',
  'VideoRewind24',
  'Wallet24',
  'Walletconnect24',
  'WcScan24',
  'Withdraw24',
  'ZoomIn24',
  'ZoomOut24',
]

const ICONS_24_SERVER_NAME_MAPPING: { [k in ServerIcon24]: Icon24 } = {
  account_summary_24: 'AccountSummary24',
  action_remove_24: 'ActionRemove24',
  agent_24: 'Agent24',
  alert_24: 'Alert24',
  alert_filled_24: 'AlertFilled24',
  all_day_trading_24: 'AllDayTrading24',
  announcement_24: 'Announcement24',
  archive_24: 'Archive24',
  arrow_down_24: 'ArrowDown24',
  arrow_down_fill_24: 'ArrowDownFill24',
  arrow_left_24: 'ArrowLeft24',
  arrow_left_fill_24: 'ArrowLeftFill24',
  arrow_right_24: 'ArrowRight24',
  arrow_right_fill_24: 'ArrowRightFill24',
  arrow_up_24: 'ArrowUp24',
  arrow_up_fill_24: 'ArrowUpFill24',
  attach_24: 'Attach24',
  backspace_24: 'Backspace24',
  banking_24: 'Banking24',
  bubble_checked_24: 'BubbleChecked24',
  bubble_dot_24: 'BubbleDot24',
  bubble_empty_24: 'BubbleEmpty24',
  bubble_pause_24: 'BubblePause24',
  bubble_plus_24: 'BubblePlus24',
  bubble_plus_filled_24: 'BubblePlusFilled24',
  bubble_radio_button_24: 'BubbleRadioButton24',
  bubble_remove_24: 'BubbleRemove24',
  bubble_remove_filled_24: 'BubbleRemoveFilled24',
  bubble_reverse_24: 'BubbleReverse24',
  bubble_uk_pounds_24: 'BubbleUkPounds24',
  bubble_uk_pounds_filled_24: 'BubbleUkPoundsFilled24',
  builder_24: 'Builder24',
  calendar_24: 'Calendar24',
  camera_24: 'Camera24',
  caret_down_24: 'CaretDown24',
  caret_left_24: 'CaretLeft24',
  caret_right_24: 'CaretRight24',
  caret_up_24: 'CaretUp24',
  cash_24: 'Cash24',
  chart_24: 'Chart24',
  chart_candlesticks_24: 'ChartCandlesticks24',
  chart_line_24: 'ChartLine24',
  chat_24: 'Chat24',
  chatbot_24: 'Chatbot24',
  checkbox_empty_24: 'CheckboxEmpty24',
  checkbox_filled_24: 'CheckboxFilled24',
  checkmark_24: 'Checkmark24',
  clipboard_24: 'Clipboard24',
  clock_24: 'Clock24',
  close_24: 'Close24',
  cloud_24: 'Cloud24',
  collapse_24: 'Collapse24',
  consumer_goods_24: 'ConsumerGoods24',
  controls_24: 'Controls24',
  conversation_24: 'Conversation24',
  copy_24: 'Copy24',
  corporate_24: 'Corporate24',
  crypto_24: 'Crypto24',
  crypto_c_24: 'CryptoC24',
  deposit_24: 'Deposit24',
  dining_24: 'Dining24',
  disclosures_24: 'Disclosures24',
  dividend_24: 'Dividend24',
  documents_24: 'Documents24',
  dollar_sign_24: 'DollarSign24',
  dot_24: 'Dot24',
  dots_24: 'Dots24',
  dots_android_24: 'DotsAndroid24',
  download_24: 'Download24',
  drag_24: 'Drag24',
  dropdown_24: 'Dropdown24',
  economic_moat_24: 'EconomicMoat24',
  edit_24: 'Edit24',
  edit_surface_24: 'EditSurface24',
  email_filled_24: 'EmailFilled24',
  email_outline_24: 'EmailOutline24',
  energy_24: 'Energy24',
  entertainment_24: 'Entertainment24',
  etf_24: 'Etf24',
  exclamation_24: 'Exclamation24',
  expand_24: 'Expand24',
  eye_24: 'Eye24',
  eye_closed_24: 'EyeClosed24',
  face_id_android_24: 'FaceIdAndroid24',
  face_id_ios_24: 'FaceIdIos24',
  fair_value_24: 'FairValue24',
  filter_24: 'Filter24',
  finance_24: 'Finance24',
  flash_off_24: 'FlashOff24',
  flash_on_24: 'FlashOn24',
  flashlight_off_24: 'FlashlightOff24',
  flashlight_on_24: 'FlashlightOn24',
  folder_24: 'Folder24',
  fullscreen_enter_24: 'FullscreenEnter24',
  fullscreen_exit_24: 'FullscreenExit24',
  gift_24: 'Gift24',
  groceries_24: 'Groceries24',
  hamburger_24: 'Hamburger24',
  healthcare_24: 'Healthcare24',
  help_24: 'Help24',
  history_24: 'History24',
  home_24: 'Home24',
  hospitality_24: 'Hospitality24',
  hourglass_24: 'Hourglass24',
  icloud_restore_24: 'IcloudRestore24',
  image_24: 'Image24',
  image_fail_24: 'ImageFail24',
  info_24: 'Info24',
  info_filled_24: 'InfoFilled24',
  l2_header_arrow_24: 'L2HeaderArrow24',
  lightbulb_24: 'Lightbulb24',
  lightning_24: 'Lightning24',
  link_24: 'Link24',
  link_out_24: 'LinkOut24',
  location_fill_24: 'LocationFill24',
  location_outline_24: 'LocationOutline24',
  lock_24: 'Lock24',
  log_out_24: 'LogOut24',
  manufacturing_24: 'Manufacturing24',
  maps_24: 'Maps24',
  margin_24: 'Margin24',
  message_send_24: 'MessageSend24',
  minus_24: 'Minus24',
  news_24: 'News24',
  no_value_24: 'NoValue24',
  notification_24: 'Notification24',
  notification_add_24: 'NotificationAdd24',
  online_24: 'Online24',
  options_down_24: 'OptionsDown24',
  options_flat_24: 'OptionsFlat24',
  options_up_24: 'OptionsUp24',
  options_volatile_24: 'OptionsVolatile24',
  order_24: 'Order24',
  pause_inline_24: 'PauseInline24',
  paycheck_24: 'Paycheck24',
  payment_24: 'Payment24',
  percent_sign_24: 'PercentSign24',
  person_24: 'Person24',
  phone_24: 'Phone24',
  pin_24: 'Pin24',
  play_inline_24: 'PlayInline24',
  plus_24: 'Plus24',
  pop_out_24: 'PopOut24',
  print_24: 'Print24',
  qr_24: 'Qr24',
  qr_scan_24: 'QrScan24',
  quantity_24: 'Quantity24',
  question_24: 'Question24',
  question_filled_24: 'QuestionFilled24',
  recurring_24: 'Recurring24',
  recurring_hub_24: 'RecurringHub24',
  resend_24: 'Resend24',
  retirement_24: 'Retirement24',
  rhw_browser_tab_24: 'RhwBrowserTab24',
  rhw_chart_tab_24: 'RhwChartTab24',
  rhw_search_tab_24: 'RhwSearchTab24',
  risk_and_uncertainty_24: 'RiskAndUncertainty24',
  robinhood_24: 'Robinhood24',
  rolling_position_24: 'RollingPosition24',
  scan_24: 'Scan24',
  search_24: 'Search24',
  settings_24: 'Settings24',
  share_android_24: 'ShareAndroid24',
  share_ios_24: 'ShareIos24',
  smiley_24: 'Smiley24',
  sound_off_24: 'SoundOff24',
  sound_on_24: 'SoundOn24',
  sparkle_bullet_24: 'SparkleBullet24',
  star_filled_24: 'StarFilled24',
  star_outline_24: 'StarOutline24',
  stewardship_24: 'Stewardship24',
  stock_down_24: 'StockDown24',
  stock_up_24: 'StockUp24',
  stopwatch_24: 'Stopwatch24',
  strategy_outlook_24: 'StrategyOutlook24',
  swipe_down_24: 'SwipeDown24',
  swipe_up_24: 'SwipeUp24',
  switch_24: 'Switch24',
  tag_24: 'Tag24',
  technology_24: 'Technology24',
  thumbprint_24: 'Thumbprint24',
  thumbs_down_24: 'ThumbsDown24',
  thumbs_up_24: 'ThumbsUp24',
  ticket_24: 'Ticket24',
  touch_id_android_24: 'TouchIdAndroid24',
  transfers_24: 'Transfers24',
  transport_24: 'Transport24',
  trash_24: 'Trash24',
  triangle_alert_24: 'TriangleAlert24',
  tuner_24: 'Tuner24',
  unlock_24: 'Unlock24',
  upload_24: 'Upload24',
  video_fast_forward_24: 'VideoFastForward24',
  video_replay_24: 'VideoReplay24',
  video_rewind_24: 'VideoRewind24',
  wallet_24: 'Wallet24',
  walletconnect_24: 'Walletconnect24',
  wc_scan_24: 'WcScan24',
  withdraw_24: 'Withdraw24',
  zoom_in_24: 'ZoomIn24',
  zoom_out_24: 'ZoomOut24',
}

export type Icon32 =
  | 'ActionsAlerts32'
  | 'ActionsAtm32'
  | 'ActionsCheck32'
  | 'ActionsStatements32'
  | 'ActionsTransfers32'
  | 'Backspace32'
  | 'Banking32'
  | 'NoValue32'
  | 'Notification32'
  | 'Payment32'
  | 'Retirement32'
  | 'Stopwatch32'
  | 'TabAccount32'
  | 'TabContent32'
  | 'TabCrypto32'
  | 'TabCryptoC32'
  | 'TabInvest32'
  | 'TabMessages32'
  | 'TabMoney32'
  | 'TabRetirement32'
  | 'TabSearch32'
  | 'VideoRewind1532'
  | 'VideoSkip1532'
  | 'Wallet32'

export type ServerIcon32 =
  | 'actions_alerts_32'
  | 'actions_atm_32'
  | 'actions_check_32'
  | 'actions_statements_32'
  | 'actions_transfers_32'
  | 'backspace_32'
  | 'banking_32'
  | 'no_value_32'
  | 'notification_32'
  | 'payment_32'
  | 'retirement_32'
  | 'stopwatch_32'
  | 'tab_account_32'
  | 'tab_content_32'
  | 'tab_crypto_32'
  | 'tab_crypto_c_32'
  | 'tab_invest_32'
  | 'tab_messages_32'
  | 'tab_money_32'
  | 'tab_retirement_32'
  | 'tab_search_32'
  | 'video_rewind_15_32'
  | 'video_skip_15_32'
  | 'wallet_32'

export const ICONS_32_LIST: Array<Icon32> = [
  'ActionsAlerts32',
  'ActionsAtm32',
  'ActionsCheck32',
  'ActionsStatements32',
  'ActionsTransfers32',
  'Backspace32',
  'Banking32',
  'NoValue32',
  'Notification32',
  'Payment32',
  'Retirement32',
  'Stopwatch32',
  'TabAccount32',
  'TabContent32',
  'TabCrypto32',
  'TabCryptoC32',
  'TabInvest32',
  'TabMessages32',
  'TabMoney32',
  'TabRetirement32',
  'TabSearch32',
  'VideoRewind1532',
  'VideoSkip1532',
  'Wallet32',
]

const ICONS_32_SERVER_NAME_MAPPING: { [k in ServerIcon32]: Icon32 } = {
  actions_alerts_32: 'ActionsAlerts32',
  actions_atm_32: 'ActionsAtm32',
  actions_check_32: 'ActionsCheck32',
  actions_statements_32: 'ActionsStatements32',
  actions_transfers_32: 'ActionsTransfers32',
  backspace_32: 'Backspace32',
  banking_32: 'Banking32',
  no_value_32: 'NoValue32',
  notification_32: 'Notification32',
  payment_32: 'Payment32',
  retirement_32: 'Retirement32',
  stopwatch_32: 'Stopwatch32',
  tab_account_32: 'TabAccount32',
  tab_content_32: 'TabContent32',
  tab_crypto_32: 'TabCrypto32',
  tab_crypto_c_32: 'TabCryptoC32',
  tab_invest_32: 'TabInvest32',
  tab_messages_32: 'TabMessages32',
  tab_money_32: 'TabMoney32',
  tab_retirement_32: 'TabRetirement32',
  tab_search_32: 'TabSearch32',
  video_rewind_15_32: 'VideoRewind1532',
  video_skip_15_32: 'VideoSkip1532',
  wallet_32: 'Wallet32',
}

export type Icon40 = 'PauseHero40' | 'PlayHero40' | 'ReplayHero40'

export type ServerIcon40 = 'pause_hero_40' | 'play_hero_40' | 'replay_hero_40'

export const ICONS_40_LIST: Array<Icon40> = [
  'PauseHero40',
  'PlayHero40',
  'ReplayHero40',
]

const ICONS_40_SERVER_NAME_MAPPING: { [k in ServerIcon40]: Icon40 } = {
  pause_hero_40: 'PauseHero40',
  play_hero_40: 'PlayHero40',
  replay_hero_40: 'ReplayHero40',
}

export type Icon = Icon12 | Icon16 | Icon24 | Icon32 | Icon40
export type ServerIcon =
  | ServerIcon12
  | ServerIcon16
  | ServerIcon24
  | ServerIcon32
  | ServerIcon40
export const ICONS_LIST: Array<Icon> = [
  ...ICONS_12_LIST,
  ...ICONS_16_LIST,
  ...ICONS_24_LIST,
  ...ICONS_32_LIST,
  ...ICONS_40_LIST,
]
export const ICONS_SERVER_NAME_MAPPING = {
  ...ICONS_12_SERVER_NAME_MAPPING,
  ...ICONS_16_SERVER_NAME_MAPPING,
  ...ICONS_24_SERVER_NAME_MAPPING,
  ...ICONS_32_SERVER_NAME_MAPPING,
  ...ICONS_40_SERVER_NAME_MAPPING,
}
